<template>
  <div>
    <b-modal
      id="memberSummaryPopup"
      ref="my-modal"
      v-model="isOpen"
      ok-only
      ok-title="Accept"
      centered
      size="lg"
      content-class="darkligntdayinpop dayinoutPopup"
    >
      <div
        v-if="loader"
        class="time-log-loader"
        style="border-radius: 12px"
      >
        <div class="time-loader-icon">
          <b-spinner
            label="Loading..."
            variant="primary"
          />
        </div>
      </div>
      <div
        class="inoutPop"
        style="background-color:#fff"
      >
        <!-- user info-->
        <div
          class="inoutHead d-flex justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center">
            <h4 class="mb-1  font-weight-bolder text-color-blue">
              Today's User Information
            </h4>
          </div>
        </div>

        <div
          class="d-flex justify-content-start flex-wrap m-0 boxShowModal"
          style="background-color: #fff; border-radius: 16px"
        >
          <div
            v-if="memberData"
            class="d-flex align-items-center flex-wrap justify-content-start w-65"
          >
            <div>
              <b-avatar
                :src="memberData && memberData.picture"
                :text="memberData.name | avatarText"
                class="m-1"
                :size="100"
              />
            </div>
            <div class="ml-1">
              <h6 class="font-weight-bolder">
                {{ memberData && memberData.full_name ? memberData.full_name : 'N/A' }}
              </h6>
              <h6 class="font-weight-bolder">
                Reporting to: {{ memberData && memberData.users && memberData.users.full_name ? memberData.users.full_name :'N/A' }}
              </h6>
              <h6 class="font-weight-bolder">
                Manage By:
                {{
                  memberData && memberData.manage_by_user && memberData.manage_by_user.full_name ? memberData.manage_by_user.full_name : 'N/A'
                }}
              </h6>
            </div>
          </div>

          <div class="d-flex align-items-center justify-content-center prodhrs ml-1 g-1">
            <div
              v-if="memberData && memberData.clock"
              class="prodhrsInfo"
            >
              <h6 class="font-weight-bolder">
                First Clock In Today :
                {{ getFormattedTime(memberData.clock, 'firstIn') }}
              </h6>
              <h6 class="font-weight-bolder">
                Last Clock In Today :
                {{ getFormattedTime(memberData.clock, 'lastIn') }}
              </h6>
              <h6 class="font-weight-bolder">
                Last Clock Out Today :
                {{ getFormattedTime(memberData.clock, 'lastOut') }}
              </h6>
            </div>

          </div>
        </div>

        <!-- user allocation-->
        <div class="poptsTable mt-1">
          <div
            class="inoutHead d-flex justify-content-between align-items-center"
          >
            <div class="d-flex align-items-center">
              <h4 class=" font-weight-bolder text-color-blue">
                Recent Time Log For Today
              </h4>
            </div>
          </div>
          <div
            v-if="memberData && memberData.user_latest_task && memberData.user_latest_task.length"
            class="project-users-container boxShowModal project-allocation"
          >
            <template>
              <b-table
                responsive
                :fields="fields"
                :items="timeLog"
                class="feild-name table-responsive scrollable-element-timesheet"
              >
                <template
                  #cell(task)="data"
                  class="task-column"
                >
                  <div class="w-full demo word-break">
                    <div class="task">
                      <div>
                        <p class="task-name">
                          <v-clamp
                            autoresize
                            :max-lines="3"
                            ellipsis="..."
                            location="end"
                            :style="{ whiteSpace: 'pre-line' }"
                            class="cursorDefault font-weight-bolder"
                          >
                            {{ data.item.title }}
                            <template #after="{ toggle, clamped, expanded }">
                              <button
                                v-if="clamped == true || expanded == true"
                                class="see-more-btn"
                                @click="toggle"
                              >
                                {{ clamped == true ? "see more" : "see less" }}
                              </button>
                            </template>
                          </v-clamp>
                        </p>
                        <div class="d-flex">
                          <p
                            class="project-name d-flex align-items-center cursorDefault"
                            :style="{ color: '#' + data.item.project.color }"
                          >
                            <feather-icon
                              class="mr-25"
                              icon="FileIcon"
                            />
                            {{ data.item.project.name }}
                          </p>
                          <span
                            v-if="data.item.project_task_number"
                            class="task-link cursorDefault"
                          >
                            <a
                              href="#"
                              class="cursorDefault"
                            >#{{ data.item.code
                            }}{{ data.item.project_task_number }}</a>
                          </span>
                        </div>
                        <div class="d-flex flex-wrap">
                          <b-badge
                            v-for="(tag, tindex) in data.item.user_task_tags"
                            :key="tindex"
                            variant="primary"
                            class="timesheet-body-badge smallBadge cursorDefault mr-1 mt-25"
                          >
                            {{ tag && tag.tag }}
                          </b-badge>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <template
                  #cell(duration)="data"
                  class="task-column"
                >
                  <div>
                    <div
                      v-if="data.item.count_minutes"
                      class="font-weight-bolder"
                      style="margin: auto; padding: auto"
                    >
                      {{ data.item.count_minutes | hoursAndMin }}
                    </div>
                  </div>
                </template>

                <template
                  #cell(time)="data"
                  class="task-column"
                >
                  <div class="mr-2">
                    <div
                      v-if="data.item.start_time && data.item.end_time"
                      style="margin: auto; padding: auto"
                      class="font-weight-bolder"
                    >
                      {{ data.item.start_time | timeFormat }} -
                      {{ data.item.end_time | timeFormat }}
                    </div>
                    <div
                      v-else
                      style="margin: auto; padding: auto"
                      class="font-weight-bolder"
                    >
                      Start At : {{ data.item.start_time | timeFormat }}
                    </div>
                  </div>
                </template>
              </b-table>
            </template>
          </div>
          <div
            v-else
            class="m-1 text-center"
          >
            <h4>No Task Log Found</h4>
          </div>
        </div>

        <div
          class="inoutHead d-flex justify-content-between align-items-center mt-1"
        >
          <div class="d-flex align-items-center">
            <h4 class=" font-weight-bolder text-color-blue">
              Project Allocation
            </h4>
          </div>
        </div>

        <div
          v-if="memberData && memberData.project_users && memberData.project_users.length"
          class="project-users-container boxShowModal project-allocation"
        >
          <template>
            <b-table
              responsive
              :fields="projectAllocationFields"
              :items="memberData.project_users"
              class="feild-name table-responsive scrollable-element-timesheet"
            >
              <template
                #cell(project)="data"
                class="task-column"
              >
                <div class="w-full demo word-break">
                  <div class="task font-weight-bolder">
                    <div>

                      {{ data.item.projects.name }}

                    </div>
                  </div>
                </div>
              </template>

              <template
                #cell(allocation)="data"
                class="task-column"
              >
                <div>
                  <div

                    class="font-weight-bolder"
                    style="margin: auto; padding: auto"
                  >
                    {{ data.item.assignment }}
                  </div>
                </div>
              </template>

              <template
                #cell(type)="data"
                class="task-column"
              >
                <div class="mr-2">
                  <b-badge
                    :variant="data.item.assignment > 80 ? 'danger' : 'warning'"
                    class="timesheet-body-badge smallBadge cursorDefault mr-2"
                  >
                    {{ data.item.assignment > 80 ? "Full Time" : "Part Time" }}
                  </b-badge>

                </div>
              </template>
            </b-table>
          </template>
        </div>

        <div
          v-else
          class="m-1 text-center"
        >
          <h4>No Project Allocation Found</h4>
        </div>
        <!-- productivity -->
        <div
          class="pophours d-flex boxShowModal mt-1 p-0"
          style="background-color: #fff; border-radius: 16px"
        >
          <div
            class="d-flex align-items-center justify-content-center flex-wrap  w-50  mr-1 "
          >
            <div
              class="prodhrsImg"
              :style="
                taskLogTotalTime < 480
                  ? 'background-color:#ffebeb'
                  : 'background-color:  #DBEEE9'
              "
            >

              <svg
                v-if="taskLogTotalTime > 479"
                width="80"
                height="88"
                viewBox="0 0 80 88"
                fill="none"
                class="svg-test"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M79.2 73.6C79.6 73.6 79.6 74 79.2 74.4L75.2 81.2C74.8 81.6 74.4 81.6 74 81.6L69.2 80C68 80.8 67.2 81.2 66 82L65.2 87.2C65.2 87.6 64.8 88 64.4 88H56.4C56 88 55.6 87.6 55.2 87.2L54.4 82C53.2 81.6 52 80.8 51.2 80L46.4 82C46 82 45.6 82 45.2 81.6L41.2 74.8C40.8 74.4 41.2 74 41.6 73.6L46 70.4V66.4L41.6 63.2C41.2 62.8 41.2 62.4 41.2 62L45.2 55.2C45.6 54.8 46 54.8 46.4 54.8L51.2 56.8C52.4 56 53.2 55.6 54.4 54.8L55.2 49.6C55.2 49.2 55.6 48.8 56.4 48.8H64.4C64.8 48.8 65.2 49.2 65.2 49.6L66 54.8C67.2 55.2 68.4 56 69.6 56.8L74.4 54.8C74.8 54.8 75.6 54.8 75.6 55.2L79.6 62C80 62.4 79.6 62.8 79.2 63.2L74.8 66.4V70.4L79.2 73.6ZM66 68C66 64.8 63.2 62 60 62C56.8 62 54 64.8 54 68C54 71.2 56.8 74 60 74C63.2 74 66 71.2 66 68ZM40 52V28H32V52M48 0H24V8H48V0ZM33.2 76C19.2 74.4 8 62.4 8 48C8 32.4 20.4 20 36 20C48.8 20 59.6 28.4 62.8 40C66 40.4 68.8 41.2 71.6 42.4C70.4 36 68 30.4 64 25.6L70 20C68 18 66 16 64 14.4L58.4 20C52.4 14.8 44.4 12 36 12C16 12 0 28 0 48C0 68 16 84 36 84H37.2C35.2 81.6 34 78.8 33.2 76Z"
                  fill="#23BC74"
                />
              </svg>

              <svg
                v-else
                width="80"
                height="88"
                viewBox="0 0 80 88"
                class="svg-test"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M79.2 73.6C79.6 73.6 79.6 74 79.2 74.4L75.2 81.2C74.8 81.6 74.4 81.6 74 81.6L69.2 80C68 80.8 67.2 81.2 66 82L65.2 87.2C65.2 87.6 64.8 88 64.4 88H56.4C56 88 55.6 87.6 55.2 87.2L54.4 82C53.2 81.6 52 80.8 51.2 80L46.4 82C46 82 45.6 82 45.2 81.6L41.2 74.8C40.8 74.4 41.2 74 41.6 73.6L46 70.4V66.4L41.6 63.2C41.2 62.8 41.2 62.4 41.2 62L45.2 55.2C45.6 54.8 46 54.8 46.4 54.8L51.2 56.8C52.4 56 53.2 55.6 54.4 54.8L55.2 49.6C55.2 49.2 55.6 48.8 56.4 48.8H64.4C64.8 48.8 65.2 49.2 65.2 49.6L66 54.8C67.2 55.2 68.4 56 69.6 56.8L74.4 54.8C74.8 54.8 75.6 54.8 75.6 55.2L79.6 62C80 62.4 79.6 62.8 79.2 63.2L74.8 66.4V70.4L79.2 73.6ZM66 68C66 64.8 63.2 62 60 62C56.8 62 54 64.8 54 68C54 71.2 56.8 74 60 74C63.2 74 66 71.2 66 68ZM40 52V28H32V52M48 0H24V8H48V0ZM33.2 76C19.2 74.4 8 62.4 8 48C8 32.4 20.4 20 36 20C48.8 20 59.6 28.4 62.8 40C66 40.4 68.8 41.2 71.6 42.4C70.4 36 68 30.4 64 25.6L70 20C68 18 66 16 64 14.4L58.4 20C52.4 14.8 44.4 12 36 12C16 12 0 28 0 48C0 68 16 84 36 84H37.2C35.2 81.6 34 78.8 33.2 76Z"
                  fill="#FF0000"
                />
              </svg>
            </div>
            <div class="prodhrsInfo">
              <span
                :style="
                  taskLogTotalTime < 480 ? 'color:#FF0000' : 'color:  #23bc74'
                "
              >{{ (taskLogTotalTime * 60) | secondsToTime }}</span>
              <h5>Productive Hours</h5>
            </div>
          </div>
          <div
            class="d-flex align-items-center justify-content-center flex-wrap w-50 prodhrs "
          >
            <div
              class="prodhrsImg position-relative"
              :style="
                taskLogTotalTime < 480
                  ? 'background-color:#ffebeb'
                  : 'background-color:  #DBEEE9'
              "
            >
              <div id="chart">
                <apexchart
                  type="radialBar"
                  width="180"
                  height="230"
                  :options="
                    taskLogTotalTime < 480 ? redChartOptions : chartOptions
                  "
                  :series="series"
                />
              </div>
              <div class="productivityImg">
                <svg
                  v-if="taskLogTotalTime > 479"
                  width="54"
                  height="54"
                  viewBox="0 0 54 54"
                  fill="none"
                  class="svg-test"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.0632 0.400349C10.2073 0.598442 8.05958 1.31784 6.53739 2.23532C3.38875 4.14327 1.41824 7.03127 0.573738 10.9619C0.271385 12.3902 0.250533 14.7361 0.532034 16.081C1.25143 19.5424 3.3679 22.7223 6.15163 24.5365L6.94401 25.0473L6.95443 38.6532V52.2695L7.19423 52.7283C7.36104 53.0723 7.54871 53.26 7.89277 53.4373L8.36194 53.6666L30.4858 53.6458L52.6097 53.6145L52.8913 53.3956C53.8713 52.6657 53.8921 51.4146 52.9434 50.7786C52.6306 50.5701 52.4638 50.5388 51.4629 50.5388H50.3265V40.0295V29.5305L50.0867 29.1239C49.6383 28.3315 49.6071 28.3315 45.4263 28.3315C41.3497 28.3315 41.2663 28.3419 40.7971 28.9884C40.5782 29.2803 40.5782 29.3741 40.5261 39.8835L40.4739 50.4867H38.7015H36.9291L36.877 43.7411C36.8248 37.1727 36.8144 36.9955 36.6163 36.714C36.5016 36.5576 36.241 36.3491 36.0429 36.2344C35.6988 36.0572 35.4278 36.0467 31.9038 36.0676C28.286 36.0989 28.1191 36.1093 27.8481 36.3178C27.6917 36.4325 27.4623 36.6619 27.3476 36.8183C27.1287 37.0998 27.1287 37.2249 27.0974 43.8245L27.0766 50.5388H25.3041H23.5317V47.8281C23.5317 44.7837 23.5004 44.6169 22.8436 44.1164L22.4578 43.8141H18.6419C13.3873 43.8141 13.8043 43.4909 13.7313 47.6196L13.6792 50.4867H11.9068H10.1344L10.1031 38.4134C10.0822 26.9449 10.0926 26.3402 10.2595 26.3923C11.4585 26.7572 13.3768 26.924 14.7635 26.7676C17.0468 26.5174 18.9651 25.8189 20.8731 24.5573C24.7724 21.9925 27.0661 17.5823 26.8368 13.1513C26.524 7.31277 23.2085 2.7879 17.9538 1.02591C16.2231 0.45248 13.8773 0.202255 12.0632 0.400349ZM15.6393 3.6324C19.059 4.32051 21.7176 6.52039 22.927 9.63776C24.1052 12.6509 23.8132 16.2061 22.1659 18.969C21.6133 19.9073 20.2684 21.3148 19.3509 21.93C16.7965 23.619 13.3456 24.1194 10.4993 23.2019C7.1421 22.1281 4.67114 19.4799 3.70153 15.9455C3.37832 14.7882 3.37832 12.2651 3.70153 11.1078C4.7754 7.17723 7.65297 4.42477 11.5523 3.56984C12.5845 3.3509 14.3986 3.37175 15.6393 3.6324ZM47.1987 40.9991V50.5388H45.4263H43.6538V40.9991V31.4593H45.4263H47.1987V40.9991ZM33.7492 44.8567V50.5388H31.9768H30.2043V44.8567V39.1745H31.9768H33.7492V44.8567ZM20.4039 48.7143V50.5388H18.6315H16.8591V48.7143V46.8897H18.6315H20.4039V48.7143Z"
                    fill="#23BC74"
                  />
                  <path
                    d="M12.8451 5.45699C12.6679 5.55082 12.4072 5.79062 12.2717 5.99914L12.011 6.37447V10.1278C12.011 13.7039 12.0214 13.9124 12.2195 14.2461C12.3342 14.4442 12.5636 14.6944 12.72 14.8195C13.0015 15.028 13.1266 15.0385 16.0771 15.0385C19.0068 15.0385 19.1528 15.028 19.4239 14.8195C19.9452 14.4337 20.112 14.1105 20.112 13.5267C20.112 12.9428 19.9452 12.6196 19.4239 12.2339C19.1632 12.0358 18.9651 12.0149 17.1093 11.9836L15.0867 11.9524V9.09565V6.24936L14.8156 5.91573C14.2943 5.3006 13.5228 5.12336 12.8451 5.45699Z"
                    fill="#23BC74"
                  />
                  <path
                    d="M43.3306 15.1216C42.8719 15.424 42.5591 16.1642 42.6529 16.696C42.7676 17.3007 43.2681 17.7803 43.9875 17.9784C44.3836 18.093 44.5609 18.1869 44.4983 18.2494C44.4358 18.312 37.5963 22.2739 29.2973 27.0698C16.9842 34.1803 14.1588 35.8485 13.9711 36.1404C13.1787 37.3185 14.3777 38.9241 15.7018 38.4654C15.879 38.4028 17.1197 37.7251 18.4438 36.9536C31.3408 29.4886 46.1978 20.9393 46.2186 20.9602C46.229 20.9706 46.1665 21.2938 46.0831 21.6587C45.9267 22.3156 45.9267 22.3677 46.1352 22.8369C46.4063 23.4416 46.865 23.7439 47.5114 23.7439C48.0432 23.7439 48.554 23.4833 48.8251 23.0662C49.1066 22.6283 50.3473 17.9158 50.2847 17.4571C50.2326 16.967 49.9928 16.6021 49.5862 16.3519C49.1587 16.0913 44.6443 14.8818 44.1021 14.8818C43.8415 14.8818 43.5496 14.9653 43.3306 15.1216Z"
                    fill="#23BC74"
                  />
                </svg>

                <svg
                  v-else
                  width="54"
                  height="54"
                  viewBox="0 0 54 54"
                  fill="none"
                  class="svg-test"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.0631 0.400349C10.2073 0.598442 8.05952 1.31784 6.53733 2.23532C3.38869 4.14327 1.41818 7.03127 0.573677 10.9619C0.271324 12.3902 0.250472 14.7361 0.531973 16.081C1.25137 19.5424 3.36784 22.7223 6.15157 24.5365L6.94394 25.0473L6.95437 38.6532V52.2695L7.19417 52.7283C7.36098 53.0723 7.54865 53.26 7.89271 53.4373L8.36188 53.6666L30.4858 53.6458L52.6097 53.6145L52.8912 53.3956C53.8712 52.6657 53.8921 51.4146 52.9433 50.7786C52.6305 50.5701 52.4637 50.5388 51.4628 50.5388H50.3264V40.0295V29.5305L50.0866 29.1239C49.6383 28.3315 49.607 28.3315 45.4262 28.3315C41.3496 28.3315 41.2662 28.3419 40.7971 28.9884C40.5781 29.2803 40.5781 29.3741 40.526 39.8835L40.4739 50.4867H38.7014H36.929L36.8769 43.7411C36.8248 37.1727 36.8143 36.9955 36.6163 36.714C36.5016 36.5576 36.2409 36.3491 36.0428 36.2344C35.6988 36.0572 35.4277 36.0467 31.9037 36.0676C28.2859 36.0989 28.1191 36.1093 27.848 36.3178C27.6916 36.4325 27.4623 36.6619 27.3476 36.8183C27.1286 37.0998 27.1286 37.2249 27.0973 43.8245L27.0765 50.5388H25.3041H23.5317V47.8281C23.5317 44.7837 23.5004 44.6169 22.8435 44.1164L22.4578 43.8141H18.6419C13.3872 43.8141 13.8042 43.4909 13.7312 47.6196L13.6791 50.4867H11.9067H10.1343L10.103 38.4134C10.0822 26.9449 10.0926 26.3402 10.2594 26.3923C11.4584 26.7572 13.3768 26.924 14.7634 26.7676C17.0467 26.5174 18.9651 25.8189 20.873 24.5573C24.7724 21.9925 27.0661 17.5823 26.8367 13.1513C26.5239 7.31277 23.2085 2.7879 17.9538 1.02591C16.2231 0.45248 13.8772 0.202255 12.0631 0.400349ZM15.6392 3.6324C19.0589 4.32051 21.7175 6.52039 22.927 9.63776C24.1051 12.6509 23.8132 16.2061 22.1659 18.969C21.6133 19.9073 20.2683 21.3148 19.3508 21.93C16.7965 23.619 13.3455 24.1194 10.4992 23.2019C7.14204 22.1281 4.67108 19.4799 3.70147 15.9455C3.37826 14.7882 3.37826 12.2651 3.70147 11.1078C4.77534 7.17723 7.65291 4.42477 11.5522 3.56984C12.5844 3.3509 14.3985 3.37175 15.6392 3.6324ZM47.1986 40.9991V50.5388H45.4262H43.6538V40.9991V31.4593H45.4262H47.1986V40.9991ZM33.7491 44.8567V50.5388H31.9767H30.2043V44.8567V39.1745H31.9767H33.7491V44.8567ZM20.4039 48.7143V50.5388H18.6315H16.859V48.7143V46.8897H18.6315H20.4039V48.7143Z"
                    fill="#FF0000"
                  />
                  <path
                    d="M12.8451 5.45699C12.6678 5.55082 12.4072 5.79062 12.2716 5.99914L12.011 6.37447V10.1278C12.011 13.7039 12.0214 13.9124 12.2195 14.2461C12.3342 14.4442 12.5636 14.6944 12.72 14.8195C13.0015 15.028 13.1266 15.0385 16.0771 15.0385C19.0068 15.0385 19.1528 15.028 19.4238 14.8195C19.9451 14.4337 20.112 14.1105 20.112 13.5267C20.112 12.9428 19.9451 12.6196 19.4238 12.2339C19.1632 12.0358 18.9651 12.0149 17.1093 11.9836L15.0866 11.9524V9.09565V6.24936L14.8156 5.91573C14.2943 5.3006 13.5228 5.12336 12.8451 5.45699Z"
                    fill="#FF0000"
                  />
                  <path
                    d="M43.3305 15.1216C42.8718 15.424 42.559 16.1642 42.6528 16.696C42.7675 17.3007 43.268 17.7803 43.9874 17.9784C44.3836 18.093 44.5608 18.1869 44.4982 18.2494C44.4357 18.312 37.5962 22.2739 29.2972 27.0698C16.9841 34.1803 14.1587 35.8485 13.971 36.1404C13.1786 37.3185 14.3776 38.9241 15.7017 38.4654C15.879 38.4028 17.1196 37.7251 18.4437 36.9536C31.3407 29.4886 46.1977 20.9393 46.2185 20.9602C46.2289 20.9706 46.1664 21.2938 46.083 21.6587C45.9266 22.3156 45.9266 22.3677 46.1351 22.8369C46.4062 23.4416 46.8649 23.7439 47.5113 23.7439C48.0431 23.7439 48.5539 23.4833 48.825 23.0662C49.1065 22.6283 50.3472 17.9158 50.2846 17.4571C50.2325 16.967 49.9927 16.6021 49.5861 16.3519C49.1586 16.0913 44.6442 14.8818 44.102 14.8818C43.8414 14.8818 43.5495 14.9653 43.3305 15.1216Z"
                    fill="#FF0000"
                  />
                </svg>
              </div>
            </div>
            <div class="prodhrsInfo">
              <span
                :style="
                  taskLogTotalTime < 480 ? 'color:#FF0000' : 'color:  #23bc74'
                "
              >{{ getProductivityValue(series) }}%</span>
              <h5>Productivity</h5>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <b-button class="d-none" />
      </template>
    </b-modal>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import html2canvas from 'html2canvas'
import * as moment from 'moment/moment'
import { BTable } from 'bootstrap-vue'
import VClamp from 'vue-clamp'

export default {
  name: 'DayInOut',
  components: {
    apexchart: VueApexCharts,
    BTable,
    VClamp,
  },
  props: {
    memberId: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      user_id: null,
      memberData: null,
      date: null,
      loader: false,
      TaskLogs: [],
      DayInOuts: [],
      dayInOutTotalTime: 0,
      firstDayIn: null,
      lastDayOut: null,
      isOpen: false,
      html2canvas,
      //   series: [0],

      /* green */
      chartOptions: {
        chart: {
          height: 200,
          type: 'radialBar',
        },
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 0,
              size: '57%',
              image: '../../assets/images/icons/productivity-icon.svg',
              imageWidth: 64,
              imageHeight: 64,
              imageClipped: false,
            },
            dataLabels: {
              name: {
                show: false,
                color: '#fff',
              },
              value: {
                show: false,
                color: '#23BC74',
                offsetY: 70,
                fontSize: '32px',
              },
            },
            track: {
              background: '#fff',
            },
          },
        },
        fill: {
          colors: ['#23BC74'],
        },
        stroke: {
          lineCap: 'round',
        },
        labels: ['Volatility'],
      },

      /*  red */
      redChartOptions: {
        chart: {
          height: 230,
          type: 'radialBar',
        },
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 0,
              size: '57%',
              image: '../../assets/images/icons/productivity-icon.svg',
              imageWidth: 64,
              imageHeight: 64,
              imageClipped: false,
            },
            dataLabels: {
              name: {
                show: false,
                color: '#fff',
              },
              value: {
                show: false,
                color: '#23BC74',
                offsetY: 70,
                fontSize: '32px',
              },
            },
            track: {
              background: '#fff',
            },
          },
        },
        fill: {
          colors: ['#FF0000'],
        },
        stroke: {
          lineCap: 'round',
        },
        labels: ['Volatility'],
        responsive: [{
          plotOptions: {
            radialBar: {
              hollow: {
                margin: 0,
                size: '7%',
              },
            },
          },

        }],
      },
      fields: [
        {
          key: 'task',
          label: 'task',
          tdClass: 'task-project-view',
          thStyle: { minWidth: '350px' },
        },

        {
          key: 'time',
          label: ' time',
          thStyle: { minWidth: '250px', textAlign: 'start !important' },
          tdClass: 'task-item',
        },
        {
          key: 'duration',
          label: 'duration',
          thStyle: { minWidth: '100px', textAlign: 'start !important' },
          tdClass: 'task-item-action',
        },
      ],

      projectAllocationFields: [
        {
          key: 'project',
          label: 'Project',
          tdClass: 'task-project-view',
          thStyle: { minWidth: '300px' },
        },

        {
          key: 'Allocation',
          label: 'Allocation (%)',
          thStyle: { width: '300px', textAlign: 'start !important' },
          tdClass: 'task-item',
        },
        {
          key: 'type',
          label: 'Type',
          thStyle: { width: '200px', textAlign: 'start !important' },
          tdClass: 'task-item-action',
        },
      ],
    }
  },
  computed: {
    taskLogTotalTime() {
      let a = 0
      if (
        this.memberData
        && this.memberData.user_latest_task
        && this.memberData.user_latest_task.length
      ) {
        this.memberData.user_latest_task.forEach(element => {
          a += element.total_time
        })
      }
      return a
    },
    series() {
      return this.taskLogTotalTime > 0
        ? [((this.taskLogTotalTime / 480) * 100).toFixed(0)]
        : [0]
    },
    timeLog() {
      return this.memberData
        && this.memberData.user_latest_task
        && this.memberData.user_latest_task.length
        ? [this.memberData.user_latest_task[0]]
        : []
    },
  },
  watch: {
    isOpen(nv) {
      this.loader = true
      setTimeout(() => {
        if (nv && this.memberId) this.getMemberDetail()
        else this.memberData = null
      }, 500)
    },
  },
  methods: {
    /** Time difference in seconds */
    timeDifference(date, starttime) {
      let time = 0
      const startDateTime = moment(`${date} ${starttime}`).format(
        'YYYY-MM-DD HH:mm',
      )
      const now = moment(new Date())
      const duration = moment.duration(now.diff(startDateTime))
      time = duration.asSeconds().toFixed(0)
      return time
    },

    /** Create new member watch list */
    async getMemberDetail() {
      const input = {
        member_id: this.memberId,
      }

      const response = await this.getHTTPPostResponse(
        'admin/master/user/get-member-detail',
        input,
        false,
      )
      if (response && response.status === 200) {
        this.memberData = response.data.member_detail
      }
      this.loader = false
    },
    
    /* se eslint error resolve */
    getProductivityValue(series) {
      return series && series.length && series[0] < 100 ? series[0] : 100
    },
  },
}
</script>
<style lang="scss" scoped>
.dayinoutPopup .inoutPop .pophours .prodhrsImg {
  width: 125px;
  height: 125px;
  min-width: 150px;
  min-height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.boxShowModal {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  /* Optional: Add a subtle shadow */
}

.text-black-color {
  color: black;
}

/*
.project-users-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  padding: 16px;

}

.project-user-card {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 16px;
  padding: 10px;

  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

}

*/
.project-allocation {
  background-color: #fff;
  border-radius: 16px;
  max-height: 190px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background-color: transparent;

    & ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 2px rgba(184, 184, 184, 0.3);
      background-color: transparent;
      border-radius: 10px;
    }
  }

  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 5px rgba(184, 184, 184, 0.3);
    border-radius: 10px;
    background-color: #b8b8b8;
  }
}
.svg-test{
  width:65px;
  height: 65px;
}
.w-65{
  width: 65%;
  @media (max-width:575px) {
    width:100%
  }
}
.w-50{
  @media (max-width:575px) {
    width:100%
  }
}

.pophours{
  @media (max-width:575px) {
    flex-wrap: wrap !important;
    justify-content: center  !important;
  }
}

.prodhrsInfo{
  @media (max-width:575px) {
    margin-top: 10px !important;
   span{
    display: block;
    text-align: center !important;

   }
  }
}

</style>
